module.exports = __webpack_public_path__ + "static/media/AppleTv.f116c93e.png";